// Vue directive: keeps an element's scrollbar invisible at rest (so it doesn't cut
// into rounded corners) and only reveals it while actively scrolling, fading it back
// out shortly after scrolling stops. Pair it with the `tw:scrollbar-autohide`
// utility defined in tailwind.css, which styles the `.is-scrolling` state.
const HIDE_DELAY = 800;

export default {
    bind(el) {
        el.__autohideScrollbar__ = () => {
            el.classList.add('is-scrolling');
            clearTimeout(el.__autohideScrollbarTimeout__);
            el.__autohideScrollbarTimeout__ = setTimeout(() => {
                el.classList.remove('is-scrolling');
            }, HIDE_DELAY);
        };
        el.addEventListener('scroll', el.__autohideScrollbar__, { passive: true });
    },
    unbind(el) {
        el.removeEventListener('scroll', el.__autohideScrollbar__);
        clearTimeout(el.__autohideScrollbarTimeout__);
        delete el.__autohideScrollbar__;
        delete el.__autohideScrollbarTimeout__;
    },
};
